/* eslint-disable react/prop-types */
import { Button, Form, Modal } from "react-bootstrap";
import BankAccountService from "../../service/bank-account-service";
import { useEffect, useState } from "react";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import PaymentOrderService from "../../service/payment-order-service";
import NumberInput from "../components/NumberInput";

const bankAccountService = new BankAccountService();
const paymentOrderService = new PaymentOrderService();

await loadDictionary('payment-order-transfer-money-window');
await loadDictionary("payment-methods");
await loadDictionary("payment-reasons");

function TransferMoneyWindow({isOpenWindow, onCloseWindow}) {
    const [bankAccounts, setBankAccounts] = useState([]);
    const [originBankAccountId, setOriginBankAccountId] = useState(0);
    const [destinationBankAccountId, setDestinationBankAccountId] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('ACH');
    const [paymentReason, setPaymentReason] = useState('NAGHDINEGI');
    const [amount, setAmount] = useState(0);
    const [description, setDescription] = useState('');
    const paymentMethods = Object.entries(i18n.t("payment-methods"));
    const paymentReasons = Object.entries(i18n.t("payment-reasons"));    

    const handleClose = () => {
        onCloseWindow();
    };

    const handleSubmit = () => {
        const payload = {
            "from_bank_account_id": Number(originBankAccountId),
            "to_bank_account_id": Number(destinationBankAccountId), 
            "amount": Number(amount),
            "payment_method": paymentMethod,
            "payment_reason": paymentReason,
            "description": description
        };

        paymentOrderService.transfer(payload).then((result) => {
            if(result) {
                handleClose();
            }
        });
    };

    useEffect(() => {
        if(!isOpenWindow) {
            return;
        }

        bankAccountService.findAll().then(bankAccounts => {
            setBankAccounts(bankAccounts.filter(bankAccount => bankAccount.party_id == null && bankAccount.type == "bank_account"));
        });
    }, [isOpenWindow]);

    return (
        <Modal backdrop="static" keyboard={false} show={isOpenWindow} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{i18n.t("payment-order-transfer-money-window.title")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form method="POST" id="TransferMoney" onSubmit={e => {e.preventDefault(); handleSubmit();}}>
                    <div className="row">
                        <Form.Group className="col mb-3">
                            <Form.Label>{i18n.t("payment-order-transfer-money-window.fromBankAccount")}</Form.Label>
                            <Form.Select autoFocus value={originBankAccountId} onChange={e => {setOriginBankAccountId(e.target.value)}}>
                                <option key={0} value={0}>{i18n.t('global.chooseOption')}</option>
                                {bankAccounts.map((bankAccount) => <option key={bankAccount.id} value={bankAccount.id}>{bankAccount.name} {bankAccount.account_number}</option>)}
                            </Form.Select>
                        </Form.Group>
                    </div>
                    <div className="row">
                        <Form.Group className="col mb-3">
                            <Form.Label>{i18n.t("payment-order-transfer-money-window.toBankAccount")}</Form.Label>
                            <Form.Select value={destinationBankAccountId} onChange={e => {setDestinationBankAccountId(e.target.value)}}>
                                <option key={0} value={0}>{i18n.t('global.chooseOption')}</option>
                                {bankAccounts.map((bankAccount) => <option key={bankAccount.id} value={bankAccount.id}>{bankAccount.name} {bankAccount.account_number}</option>)}
                            </Form.Select>
                        </Form.Group>
                    </div>
                    <div className="row">
                        <NumberInput className="col mb-3" label={i18n.t("payment-order-transfer-money-window.amount")} value={amount} onChange={setAmount} />
                    </div>
                    <div className="row">
                        <Form.Group className="col mb-3">
                            <Form.Label>{i18n.t("payment-order-transfer-money-window.paymentMethod")}</Form.Label>
                            <Form.Select value={paymentMethod} onChange={e => {setPaymentMethod(e.target.value)}}>
                                {paymentMethods.map((item) => <option key={item[0]} value={item[0]}>{item[1]}</option>)}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="col mb-3">
                            <Form.Label>{i18n.t("payment-order-transfer-money-window.paymentReason")}</Form.Label>
                            <Form.Select value={paymentReason} onChange={e => {setPaymentReason(e.target.value)}}>
                                {paymentReasons.map((item) => <option key={item[0]} value={item[0]}>{item[1]}</option>)}
                            </Form.Select>
                        </Form.Group>
                    </div>
                    <div className="row">
                        <Form.Group className="col mb-3">
                            <Form.Label>{i18n.t("payment-order-transfer-money-window.description")}</Form.Label>
                            <Form.Control type="text" value={description} onChange={e => {setDescription(e.target.value)}} />
                        </Form.Group>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>{i18n.t("payment-order-transfer-money-window.cancel")}</Button>
                <Button variant="primary" type="submit" form="TransferMoney">{i18n.t("payment-order-transfer-money-window.action")}</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default TransferMoneyWindow;